module.exports = __webpack_public_path__ + "img/safe_tool_9.133ba290.jpg";